import { sendMQTTMessage, parseMqttResult } from '../helper'
import { IFile as IHeziFile } from '@remote/type/hezi'
import { IMQTTRes } from '../type'

export function deleteHeziFile (paths: string[], isMainSpace = false) {
  return sendMQTTMessage('xl_shell', 'rm -rf', {
    ver: 1,
    is_main_space: isMainSpace,
    paths,
  }).then(res => parseMqttResult(res, [0, 10104]))
}

export function makeDir (path: string) {
  return sendMQTTMessage<{ data: string }>('xl_shell', 'mkdir', {
    ver: 1,
    path,
  }).then(parseMqttResult)
}

export function moveFile (srcPath: string, dstPath: string) {
  return sendMQTTMessage<{ data: string }>('xl_shell', 'mv', {
    ver: 1,
    src_path: srcPath, // 源文件路径
    dst_path: dstPath,  // 目标文件路径
  }).then(parseMqttResult)
}

type TShearFilesParams = {
  src_paths: string[] //源文件路径， 支持批量
  dst_path: string // 目标文件路径
  rename: boolean // 是否允许重命名
  group_id: string //用于统计客户端
}

export function shearFiles (params: TShearFilesParams) {
  return sendMQTTMessage<{ data: string }>('xl_shell', 'shear -r', params).then(parseMqttResult)
}

export function copyFiles (params: TShearFilesParams) {
  return sendMQTTMessage<{ data: string }>('xl_shell', 'cp -r', params).then(parseMqttResult)
}

export function createFolder (path: string) {
  return sendMQTTMessage<{ data: string }>('xl_shell', 'mkdir', {
    ver: 1,
    path: path,  // 目标文件路径
  }).then(parseMqttResult)
}

export function fileExit (path: string) {
  return sendMQTTMessage('xl_shell', 'is_file_exist', {
    ver: 1,
    file_path: path,
  })
}

type TFileBatchExitResultItem = {
  file_path: string
  exist: boolean
}

export function fileBatchExit (paths: string[]): Promise<IMQTTRes<{ files: TFileBatchExitResultItem[] }>> {
  return sendMQTTMessage('xl_shell', 'is_file_exists', {
    ver: 1,
    file_paths: paths,
  }).then(parseMqttResult)
}

export function getFileInfo (path: string): Promise<IMQTTRes<IHeziFile>> {
  return sendMQTTMessage('xl_shell', 'get_file_info', {
    ver: 1,
    file_path: path,
  }).then(parseMqttResult)
}

export type TGetFileInfoBatchRes = IMQTTRes<{ data: IHeziFile[] }>

export function getFileInfoBatch (filePaths: string[]): Promise<TGetFileInfoBatchRes> {
  return sendMQTTMessage('xl_shell', 'get_file_info_batch', {
    file_paths: filePaths,
  })
    .then(parseMqttResult)
}